import CalendarFetchOrder from '../store/schema/CalendarFetchOrder';
import createCalendarEventKey from '../utils/createCalendarEventKey';
import { CalendarEvent } from 'mini-calendar-event-types';
import { endOfDay, getTimestamp, OwaDate, startOfDay } from 'owa-datetime';
import getCalendarEventsForRange, {
    GetCalendarEventsForRangeResponse,
} from './getCalendarEventsForRange';

/**
 * Returns calendar events for a given set of days
 * @param days Array of dates
 */
export async function getCalendarEventsForDays(days: OwaDate[]): Promise<CalendarEvent[][]> {
    const responsePromises: Promise<GetCalendarEventsForRangeResponse>[] = [];
    for (const day of days) {
        const startOfDayKey = createCalendarEventKey(getTimestamp(startOfDay(day)), null);
        const endOfDayKey = createCalendarEventKey(getTimestamp(endOfDay(day)), null);
        responsePromises.push(
            getCalendarEventsForRange(
                {
                    start: startOfDayKey,
                    end: endOfDayKey,
                },
                CalendarFetchOrder.Ascending
            )
        );
    }

    const responses = await Promise.all(responsePromises);
    return responses.map(response => response.events);
}
